import { useInfiniteQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';

const PAGE_SIZE = 20;

export function useInfiniteTaskActivity(taskId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, hasNextPage, fetchNextPage, isFetchingNextPage, isLoading, isError } =
    useInfiniteQuery({
      queryKey: TASK_KEYS.activity(orgId ?? '', taskId, {}),
      queryFn: ({ pageParam, signal }: { pageParam: number; signal: AbortSignal }) =>
        tasksService.getTaskActivity(taskId, { Page: pageParam, PageSize: PAGE_SIZE }, signal),
      initialPageParam: 1,
      getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.page + 1 : undefined),
      staleTime: 60_000,
      enabled: !!orgId && !!taskId,
    });

  const activities = data?.pages.flatMap((p) => p.items ?? []) ?? [];
  const totalCount = data?.pages[0]?.totalCount ?? 0;

  return {
    activities,
    totalCount,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
  };
}
